<template>
  <div>
    <b-row class="justify-content-md-center m-0">
      <b-col lg="6">
        <div ref="text__title-page" class="h5 display-4 mt-1 mb-4 font-weight-bold">
          Design and planning
        </div>
        <div class="d-flex justify-content-between mb-4">
          <div
            ref="text__title-list"
            class="h5 font-weight-bold font-size-lg d-flex align-items-center"
          >
            My Micro-Credentials
          </div>
          <b-button ref="button__create-mc" variant="first" @click="goToCreatePage()">
            <span>Create Micro-Credential</span>
          </b-button>
        </div>

        <ListMemberLearningUnit ref="component__list-member-learning-unit" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ListMemberLearningUnit from './components/ListMemberLearningUnit';
import { userInfoMixin } from '@/mixins';

export default {
  components: {
    ListMemberLearningUnit
  },

  mixins: [userInfoMixin],

  updated() {
    if (this.user && !(this.user.isRole('designer') || this.user.isRole('teacher'))) {
      this.$router.push({
        name: 'learning-unit'
      });
    }
  },

  methods: {
    goToCreatePage() {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      if (!baseUrl) {
        console.error('Missing Catalog base URL');
        return;
      }

      const url = new URL('/ets-4life/learning-units/create', baseUrl);

      window.open(url.toString(), '_blank', 'noopener,noreferrer');
    }
  }
};
</script>
